import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  margin: 5% 10% 10% 10%;
  display: flex;
  justify-content: space-between;
`;

const IntroductionWrapper = styled.div`
  width: 70%;
`;

const IntroductionHeader = styled.div`
  width: 100%;
`;

const IntroductionTitle = styled.h1`
  font-size: 24px;
  text-align: left;
  display: block;
`;

const IntroductionBody = styled.div`
  display: flex;
`;

const IntroductionBodyHeader = styled.h2`
  padding-top: 10px;
  font-size: 16px;
`;

const IntroductionBodyParagraph = styled.p`
  flex: 1;
  padding-top: 10px;
  line-height: 1.5;
`;

const HomeImageContainer = styled.div`
  flex: 1;
  text-align: center;
`;

const HomeImage = styled.img`
  padding-top: 10px;
  width: 80%;
`;

const SidebarWrapper = styled.div`
  width: 30%;
`;

const Welcome = () => {
  return (
    <Container>
      <IntroductionWrapper>
        <IntroductionHeader>
          <IntroductionTitle>About Me</IntroductionTitle>
        </IntroductionHeader>
        <IntroductionBody>
          <IntroductionBodyHeader></IntroductionBodyHeader>
          <IntroductionBodyParagraph>
            My name is Blaine Billings, and I am a Ph.D. candidate in
            Linguistics at the University of Hawai'i at Mānoa. My research
            interests are language documentation, documentary lexicography,
            historical linguistics, and computational linguistics. I have
            carried out fieldwork in Indonesia and am currently most involved in
            the documentation of Nasal as part of a larger documentary project
            (NSF #1911641). My dissertation research focuses on the
            documentation of the Nasal lexicon and collaborative efforts to
            produce dictionary outputs. Beyond research, I very much enjoy
            teaching and look forward to continue doing so in the future.
          </IntroductionBodyParagraph>
          <HomeImageContainer>
            <HomeImage
              src="../imgs/BlaineBillings.JPG"
              alt="Blaine Billings."
            ></HomeImage>
          </HomeImageContainer>
        </IntroductionBody>
      </IntroductionWrapper>
      <SidebarWrapper></SidebarWrapper>
    </Container>
  );
};

export default Welcome;
